/* FLM — explicit demo mode. The app is real-data-only; the FLM_DATA mock layer
   exists ONLY behind `?demo=1` (design review in a plain browser). The flag is
   persisted to sessionStorage so in-app navigation keeps it for the session. */

try {
  if (new URLSearchParams(window.location.search).get('demo') === '1') {
    sessionStorage.setItem('flm.demo', '1');
  }
} catch {
  /* sessionStorage unavailable (private mode edge cases) — default to real data */
}

/** True only when the session was opened with ?demo=1 — the mock-data escape hatch. */
export function isDemo() {
  try {
    return sessionStorage.getItem('flm.demo') === '1';
  } catch {
    return false;
  }
}
